import styled from 'styled-components'

import Text from './Text'

/**
 * エラーテキスト
 */
const ErrorText = styled(Text)`
  color: var(--color-content-background);
  font-size: 15px;
`

export default ErrorText
